var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/previous") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/previous",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2707187,24.4199464 L12.7720158,30.0813676 C10.4738258,31.6123096 7.36970086,30.9903322 5.8387588,28.6921422 C5.29183067,27.8711152 5,26.9066434 5,25.9201264 L5,14.5972841 C5,11.8358603 7.23857625,9.59728409 10,9.59728409 C10.986517,9.59728409 11.9509888,9.88911476 12.7720158,10.4360429 L21.2707187,16.097464 C23.5689088,17.6284061 24.1908862,20.732531 22.6599441,23.030721 C22.2932998,23.5811131 21.8211108,24.0533021 21.2707187,24.4199464 Z M30.2587052,9 C32.4678442,9 34.2587052,10.790861 34.2587052,13 L34.2587052,27 C34.2587052,29.209139 32.4678442,31 30.2587052,31 C28.0495662,31 26.2587052,29.209139 26.2587052,27 L26.2587052,13 C26.2587052,10.790861 28.0495662,9 30.2587052,9 Z",
    id: "previous",
    fill: "#DB7940",
    transform: "translate(19.629353, 20.000000) scale(-1, 1) translate(-19.629353, -20.000000) "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.5c524925a1831664a62970df7574701e.svg";
export { ForwardRef as ReactComponent };